import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a5aa8e84"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "material-cont"
};
const _hoisted_2 = {
  key: 1,
  class: "cont"
};
const _hoisted_3 = {
  key: 0,
  class: "title"
};
const _hoisted_4 = /*#__PURE__*/_createTextVNode("根据国家相关政策要求");
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_6 = /*#__PURE__*/_createTextVNode("对众筹发起者资质公示如下：");
const _hoisted_7 = [_hoisted_4, _hoisted_5, _hoisted_6];
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = ["href"];
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  key: 1,
  class: "footer"
};
const _hoisted_12 = /*#__PURE__*/_createTextVNode("以上经营信息由发起者自行申报填写。");
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_14 = /*#__PURE__*/_createTextVNode("如需进一步核实，请联系相关行政管理部门。");
const _hoisted_15 = [_hoisted_12, _hoisted_13, _hoisted_14];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_loading = _resolveComponent("van-loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.loading ? (_openBlock(), _createBlock(_component_van_loading, {
    key: 0,
    type: "spinner",
    size: "66"
  })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [!$data.isNone ? (_openBlock(), _createElementBlock("p", _hoisted_3, _hoisted_7)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "list",
      key: index
    }, [item.file_url && item.file_url.toLowerCase().includes('.pdf') ? (_openBlock(), _createElementBlock("p", _hoisted_8, [_createElementVNode("a", {
      href: item.file_url,
      target: "_blank",
      class: "pdf-link"
    }, _toDisplayString(item.file_name), 9, _hoisted_9)])) : item.file_url ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createElementVNode("img", {
      src: item.file_url,
      class: _normalizeClass({
        'none': $data.isNone
      })
    }, null, 10, _hoisted_10), _createElementVNode("p", null, _toDisplayString(item.file_name), 1)], 64)) : _createCommentVNode("", true)]);
  }), 128)), !$data.isNone ? (_openBlock(), _createElementBlock("p", _hoisted_11, _hoisted_15)) : _createCommentVNode("", true)]))]);
}